// Asked before building a renderer, which throws when the browser will not give it a context.
export function hasWebGl2(): boolean {
  let gl: WebGL2RenderingContext | null;
  try {
    gl = document.createElement("canvas").getContext("webgl2");
  } catch {
    return false;
  }
  if (!gl) return false;

  // Hand the probe's own context back: a tab holds only a handful (~16 in Chrome).
  gl.getExtension("WEBGL_lose_context")?.loseContext();
  return true;
}
